"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequest = exports.deleteRequest = exports.getResponse = exports.getRequest = exports.proxyApi = void 0;
const sha1_1 = __importDefault(require("sha1"));
const uuid4_1 = __importDefault(require("uuid4"));
const serialize_1 = require("near-api-js/lib/utils/serialize");
const utils_1 = require("../utils");
exports.proxyApi = "https://h4n.app";
const getRequest = (id, signal) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch(`${exports.proxyApi}/${id}/request`, {
        signal,
        headers: { "content-type": "application/json" },
        method: "GET",
    });
    if (res.ok === false) {
        throw Error(yield res.text());
    }
    const { data } = yield res.json();
    return JSON.parse(Buffer.from((0, serialize_1.base_decode)(data)).toString("utf8"));
});
exports.getRequest = getRequest;
const getResponse = (id) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const res = yield fetch(`${exports.proxyApi}/${id}/response`, {
        headers: { "content-type": "application/json" },
        method: "GET",
    });
    if (res.ok === false) {
        throw Error(yield res.text());
    }
    const { data } = yield res.json();
    const result = (_a = JSON.parse(data)) !== null && _a !== void 0 ? _a : {};
    return Object.assign({ type: "here", public_key: "", account_id: "", payload: "", status: -1, path: "" }, result);
});
exports.getResponse = getResponse;
const deleteRequest = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch(`${exports.proxyApi}/${id}`, {
        headers: { "content-type": "application/json" },
        method: "DELETE",
    });
    if (res.ok === false) {
        throw Error(yield res.text());
    }
});
exports.deleteRequest = deleteRequest;
const createRequest = (request, signal) => __awaiter(void 0, void 0, void 0, function* () {
    const query = (0, serialize_1.base_encode)(JSON.stringify(Object.assign(Object.assign({}, request), { _id: (0, uuid4_1.default)() })));
    const hashsum = (0, sha1_1.default)(query);
    const id = Buffer.from(hashsum, "hex").toString("base64");
    const urlsafe = id.replaceAll("/", "_").replaceAll("-", "+").slice(0, 13);
    const res = yield fetch(`${exports.proxyApi}/${urlsafe}/request`, {
        method: "POST",
        signal,
        body: JSON.stringify({
            topic_id: (0, utils_1.getDeviceId)(),
            data: query,
        }),
        headers: {
            "content-type": "application/json",
        },
    });
    if (res.ok === false) {
        throw Error(yield res.text());
    }
    return urlsafe;
});
exports.createRequest = createRequest;
//# sourceMappingURL=methods.js.map